<template>
  <div class="applicat-box">
    <div class="a-tip" v-show="false">
      <div class="at-title">
        <span>编辑申请主体</span>
        <span class="warning"
          >（ 该申请主体信息审核中，暂时无法修改申请主体信息！）</span
        >
      </div>
    </div>
    <div class="applicat">
      <div class="al-title">申请人信息</div>
      <div class="al-basic-info">
        <!-- 申请人类型 -->
        <div class="al-basic-info-item">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人类型：</span>
          </div>
          <span class="al-row-content">{{
            applicant.applicantType == 0 ? "个人/个体工商户" : "企业"
          }}</span>
        </div>
        <!-- 书式类型 -->
        <div class="al-basic-info-item">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>书式类型：</span>
          </div>
          <span class="al-row-content">{{ bookType[applicant.bookType] }}</span>
        </div>
        <!-- 主体资格证明文件类型 -->
        <div
          v-if="applicant.applicantType == 0 && applicant.bookType == 1"
          class="al-basic-info-item"
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>主体资格证明文件类型：</span>
          </div>
          <span class="al-row-content">{{
            applicant.personalSubjectType == 1
              ? "个体工商户营业执照"
              : applicant.personalSubjectType == 2
              ? "农村土地承包经营合同复印件"
              : "其他"
          }}</span>
        </div>
        <!-- 申请人名称 -->
        <div class="al-basic-info-item">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人名称：</span>
          </div>
          <span class="al-row-content">{{ applicant.applicantName }}</span>
        </div>
        <!-- 申请人名称（英文） -->
        <div v-if="applicant.bookType != 1" class="al-basic-info-item">
          <div class="al-row-title">
            <span class="al-row-dage">
              <span v-show="applicant.bookType == 2">*</span>
            </span>
            <span
              >申请人名称<br /><span class="al-row-dage"></span>（英文）：</span
            >
          </div>
          <span class="al-row-content">{{
            applicant.applicantEnglishName
          }}</span>
        </div>
        <!-- 国家或地区 -->
        <div class="al-basic-info-item" v-if="applicant.bookType == 2">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>国家或地区：</span>
          </div>
          <span class="al-row-content">{{ applicant.country }}</span>
        </div>
        <!-- 统一社会信用代码 -->
        <div
          class="al-basic-info-item"
          v-if="
            (applicant.applicantType == 1 && applicant.bookType == 1) ||
            (applicant.applicantType == 0 && applicant.personalSubjectType == 1)
          "
        >
          <div class="al-row-title">
            <span class="al-row-dage">
              <span
                v-show="
                  (applicant.applicantType == 1 && applicant.bookType == 1) ||
                  (applicant.applicantType == 0 &&
                    applicant.applicantDetailType == 2)
                "
                >*</span
              >
            </span>
            <span
              >统一社会信<br /><span class="al-row-dage"></span>用代码：</span
            >
          </div>
          <span class="al-row-content">{{ applicant.creditCode }}</span>
        </div>
        <!-- 证件类型 -->
        <div class="al-basic-info-item" v-if="applicant.applicantType == 0">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>证件类型：</span>
          </div>
          <span class="al-row-content">{{
            certificatesType[applicant.certificatesType]
          }}</span>
        </div>
        <!-- 证件号码 -->
        <div class="al-basic-info-item" v-if="applicant.applicantType == 0">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>证件号码：</span>
          </div>
          <span class="al-row-content">{{ applicant.idCard }}</span>
        </div>
        <!-- 申请人地址 -->
        <div class="al-basic-info-item" v-if="applicant.bookType == 1">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人地址：</span>
          </div>
          <span class="al-row-content"
            >{{ applicant.provinceName }}/{{ applicant.cityName }}</span
          ><span v-if="applicant.areaName && applicant.areaName != 0"
            >/{{ applicant.areaName }}</span
          >
        </div>
        <!-- 申请人详细地址 -->
        <div class="al-basic-info-item">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人详细地址：</span>
          </div>
          <span class="al-row-content">{{ applicant.applicantAddress }}</span>
        </div>
        <!-- 申请人地址（英文） -->
        <div v-if="applicant.bookType != 1" class="al-basic-info-item">
          <div class="al-row-title">
            <span class="al-row-dage">
              <span v-show="applicant.bookType == 2">*</span>
            </span>
            <span
              >申请人地址<br /><span class="al-row-dage"></span>（英文）：</span
            >
          </div>
          <span class="al-row-content">{{
            applicant.applicantEnglishAddress
          }}</span>
        </div>
        <!-- 申请人邮箱 -->
        <div class="al-basic-info-item" v-show="false">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>申请人邮箱：</span>
          </div>
          <span class="al-row-content">{{
            applicant.domesticReceiverEmail
          }}</span>
        </div>
        <!-- 邮政编码 -->
        <div class="al-basic-info-item">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>邮政编码：</span>
          </div>
          <span class="al-row-content">{{ applicant.code }}</span>
        </div>
        <!-- 有效期限 -->
        <div class="al-basic-info-item" v-show="false">
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span
              >{{ applicant.applicantType == 1 ? "营业" : "有效" }}期限：</span
            >
          </div>
          <div class="al-row-content">
            <span v-if="applicant.limitStartTime">{{
              applicant.limitStartTime.split(" ")[0]
            }}</span>
            <span v-if="!applicant.limitType && applicant.limitEndTime"
              >至 {{ applicant.limitEndTime.split(" ")[0] }}</span
            >
            <span
              v-if="applicant.limitType"
              style="display: inline-block"
              :style="{
                marginLeft:
                  applicant.limitStartTime || applicant.limitEndTime
                    ? '10px'
                    : '0px',
              }"
              >{{ applicant.limitType ? "长期" : "" }}</span
            >
          </div>
        </div>
        <!-- 主体资格证明原文件是否为中文  -->
        <div
          class="al-basic-info-item"
          v-if="
            applicant.bookType == 3 ||
            applicant.bookType == 4 ||
            applicant.bookType == 5
          "
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>材料是否英<br /><span class="al-row-dage"></span>文：</span>
          </div>
          <span class="al-row-content">{{
            applicant.subjectType == 1 ? "中文" : "英文"
          }}</span>
        </div>
      </div>
      <div class="al-title" style="margin-top: 24px">材料信息</div>
      <div class="al-file-line">
        <!-- 身份证  -->
        <div
          v-if="applicant.applicantType == 0"
          class="al-row"
          style="align-items: flex-start"
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>身份证</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <div class="upload-item upload-hover">
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('applicantIdCardImg')">预览</p>
                </div>
              </div>
              <div class="upload-give" @click="fileView('sfz')">
                <img class="icon-file" :src="fileList.sfz" alt="" />
                <img
                  class="icon-give"
                  src="@/assets/img/common/icon-give.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 身份证（英文）  -->
        <div
          v-if="applicant.applicantType == 0 && applicant.subjectType == 0"
          class="al-row"
          style="align-items: flex-start"
        >
          <div class="al-row-title" style="width: auto">
            <span class="al-row-dage">*</span>
            <span>身份证（英文）</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <div class="upload-item upload-hover">
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('idCardEnglishPic')">预览</p>
                </div>
              </div>
              <div class="upload-give" @click="fileView('hwsfzm')">
                <img class="icon-file" :src="fileList.hwsfzm" alt="" />
                <img
                  class="icon-give"
                  src="@/assets/img/common/icon-give.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 营业执照  -->
        <div
          v-if="
            (applicant.applicantType == 1 ||
              (applicant.applicantType == 0 && applicant.bookType == 1)) &&
            applicant.applicantQualification
          "
          class="al-row"
          style="align-items: flex-start"
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>营业执照</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <div class="upload-item upload-hover">
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('applicantQualification')">预览</p>
                </div>
              </div>
              <div
                class="upload-give"
                @click="
                  fileView(applicant.applicantType == 1 ? 'give2' : 'give1')
                "
              >
                <img
                  class="icon-file"
                  :src="
                    applicant.applicantType == 1
                      ? fileList.give2
                      : fileList.give1
                  "
                  alt=""
                />
                <img
                  class="icon-give"
                  src="@/assets/img/common/icon-give.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 营业执照（英文）  -->
        <div
          v-if="applicant.applicantType == 1 && applicant.subjectType == 0"
          class="al-row"
          style="align-items: flex-start"
        >
          <div class="al-row-title" style="width: auto">
            <span class="al-row-dage">*</span>
            <span>营业执照（英文）</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <div class="upload-item upload-hover">
                <img class="file-img" :src="fileList.pdf" alt="" />
                <div class="upload-hove-loading">
                  <p @click="onPreview('licenseEnglishPic')">预览</p>
                </div>
              </div>
              <div class="upload-give" @click="fileView('hwgsh')">
                <img
                  class="icon-file"
                  src="@/assets/img/file/hwgsh.jpg"
                  alt=""
                />
                <img
                  class="icon-give"
                  src="@/assets/img/common/icon-give.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="al-title" style="margin-top: 24px">委托书信息</div>
      <div class="al-file-line">
        <!-- 委托书模版  -->
        <div
          class="al-row1"
          style="align-items: flex-start"
          v-if="applicant.applicantProxy"
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>委托书模版</span>
          </div>
          <div class="al-upload">
            <div class="upload-box">
              <div class="upload-item upload-hover">
                <img
                  class="file-img"
                  :src="
                    applicant.applicantProxy.indexOf('http://') > -1 ||
                    applicant.applicantProxy.indexOf('https://') > -1
                      ? applicant.applicantProxy
                      : fileUrl + applicant.applicantProxy
                  "
                  alt=""
                />
                <div class="upload-hove-loading">
                  <p @click="onPreview('applicantProxy')">预览</p>
                </div>
              </div>
              <div
                class="upload-give"
                @click="
                  fileView(applicant.applicantType == 1 ? 'wts2' : 'wts2')
                "
              >
                <img
                  class="icon-file"
                  :src="
                    applicant.applicantType == 1 ? fileList.wts2 : fileList.wts1
                  "
                  alt=""
                />
                <img
                  class="icon-give"
                  src="@/assets/img/common/icon-give.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 委托书模版生成结果  -->
        <div
          class="al-row1"
          style="align-items: flex-start"
          v-if="applicant.simpleUrl"
        >
          <div class="al-row-title">
            <span class="al-row-dage">*</span>
            <span>委托书模版生成结果</span>
          </div>
          <div class="al-upload">
            <div class="upload-tip"></div>
            <div class="upload-box">
              <div class="upload-item upload-hover">
                <img
                  class="file-img"
                  :src="
                    applicant.simpleUrl.indexOf('http://') > -1 ||
                    applicant.simpleUrl.indexOf('https://') > -1
                      ? applicant.simpleUrl
                      : fileUrl + applicant.simpleUrl
                  "
                  alt=""
                />
                <div class="upload-hove-loading">
                  <p @click="onPreview('simpleUrl')">预览</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 委托书模版复用法律声明  -->
      <div
        class="al-row1"
        style="align-items: flex-start"
        v-if="applicant.applicantProxyStatement"
      >
        <div class="al-row-title">
          <span class="al-row-dage">*</span>
          <span>委托书模版复用法律声明</span>
        </div>
        <div class="al-upload">
          <div class="upload-tip"></div>
          <div class="upload-box">
            <div class="upload-item upload-hover">
              <img
                class="file-img"
                :src="
                  applicant.applicantProxyStatement.indexOf('http://') > -1 ||
                  applicant.applicantProxyStatement.indexOf('https://') > -1
                    ? applicant.applicantProxyStatement
                    : fileUrl + applicant.applicantProxyStatement
                "
                alt=""
              />
              <div class="upload-hove-loading">
                <p @click="onPreview('applicantProxyStatement')">预览</p>
              </div>
            </div>
            <div
              class="upload-give"
              @click="fileView(applicant.applicantType == 1 ? 'sm2' : 'sm1')"
            >
              <img
                class="icon-file"
                :src="
                  applicant.applicantType == 1 ? fileList.sm2 : fileList.sm1
                "
                alt=""
              />
              <img
                class="icon-give"
                src="@/assets/img/common/icon-give.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _validate from "@/framework/common/qds_validate";
import { downloadPowerAttorney } from "@/server/applicant";
export default {
  props: ["applicant"],
  data() {
    return {
      uploadUrl: `https://phoenix.quandashi.com/upload/upload`,
      bookType: {
        1: "中国大陆",
        2: "海外",
        3: "中国台湾",
        4: "中国香港",
        5: "中国澳门",
      },
      certificatesType: {
        1: "身份证",
        2: "护照",
        3: "其他",
        4: "营业执照",
        5: "事业单位法人证书",
        6: "社会团体法人登记证书",
        7: "民办非企业单位登记证书",
        8: "基金会法人登记证书",
        9: "律师事务所执业许可证",
      },
      fileList: {
        sfz: require("../../../assets/img/files/sfz.jpg"),
        give1: require("../../../assets/img/files/give1.jpg"),
        give2: require("../../../assets/img/files/give2.jpg"),
        sm1: require("../../../assets/img/files/sm1.jpg"),
        sm2: require("../../../assets/img/files/sm2.jpg"),
        wts1: require("../../../assets/img/files/wts1.jpg"),
        wts2: require("../../../assets/img/files/wts1.jpg"),
        hwsfzm: require("../../../assets/img/file/hwsfzm.jpg"),
        give: require("../../../assets/img/file/give2.png"),
        hwgsh: require("../../../assets/img/file/hwgsh.jpg"),
        wts: require("../../../assets/img/file/wts.png"),
        wtsCopy: require("../../../assets/img/file/wts-copy.png"),
        pdf: require("../../../assets/img/file/icon-pdf.png"),
      },
      fileUrl: this.$imgBaseUrl,
    };
  },

  mounted() {},

  methods: {
    // 预览
    onPreview(name) {
      let self = this;
      if (!_validate.checkEmpty(name)) {
        let url =
          self.applicant[name].indexOf("http://") > -1 ||
          self.applicant[name].indexOf("https://") > -1
            ? self.applicant[name]
            : self.$imgBaseUrl + self.applicant[name];
        window.open(url, "_blank");
      } else {
        _tools.openTip(self, "预览链接有误，请稍后刷新重试！", "warning");
      }
    },
    // 查看文件示例
    fileView(img) {
      window.open(this.fileList[img]);
    },
    // 下载生成委托书模板
    async downloadPowerAttorney() {
      let self = this;
      let params = {
        applicantName: self.applicant.applicantName,
        address: self.applicant.applicantAddress,
        isClient: 2,
        pageType: 2,
      };
      let res = await downloadPowerAttorney(params);
      window.open(
        res.docUrl.indexOf("http://") > -1 ||
          res.docUrl.indexOf("https://") > -1
          ? res.docUrl
          : this.$imgBaseUrl + res.docUrl
      );
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
<style lang="less" scoped>
.applicat-box {
  font-size: 12px;
  font-family: SourceHanSansSC-Normal, SourceHanSansSC;
  font-weight: 400;
  color: #666666;
}

&:deep(.el-icon-arrow-up) {
  line-height: 32px;
}

&:deep(.el-input__suffix) {
  display: flex;
  align-items: center;
}
</style>
